import { Component, OnInit, Input } from '@angular/core';
import { ParentService } from '@app/dashboard/services/parent.service';
import {ToastrService} from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import {count} from 'rxjs/operators';

@Component({
  selector: 'app-completed-reviews',
  templateUrl: './completed-reviews.component.html',
  styleUrls: ['./completed-reviews.component.scss']
})
export class CompletedReviewsComponent implements OnInit {

  isMobileDevice: boolean;
  completedReviews =  [];
  areaOfFocusId: string;
  areaOfFocus = [];

  constructor(private parentService: ParentService,
              private toastr: ToastrService,
              private router: Router) {
    this.isMobileDevice = true;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
  }

  ngOnInit(): void {
    this.loadAreasOfFocus();
  }

  loadAreasOfFocus() {
    this.parentService.getAreasOfFocus().subscribe((response) => {
      if (response.status === 200) {
        this.areaOfFocus.push.apply(this.areaOfFocus, response.body.result);
        this.getCompletedReviews();
      } else {
        this.toastr.error('Encountered problem loading Areas Of Focus Info', 'Error!');
      }
    }, (error => this.toastr.error(error, 'Error!')));
  }

  getCompletedReviews() {
    this.parentService.getCompletedGabadooReviews().subscribe((response) => {
      if (response.status === 200) {
        this.completedReviews = response.body.result;
        this.assignCorrectProblemNamesToCards(response.body.result);

      } else {
        this.toastr.error('Encountered problem loading reviews options', 'Error!');
      }
    }, (error => this.toastr.error(error, 'Error!')));

  }

  assignCorrectProblemNamesToCards(responseArray){
    responseArray.forEach((element, index) => {
      this.areaOfFocusId = element.reviewDetails.areaOfFocus;
      if (this.areaOfFocusId === undefined) {
        this.completedReviews[index].reviewDetails.areaOfFocus = 'N/A';
      }else {
        const selectedAreaFocusDetail = this.areaOfFocus.find(area => area._id === this.areaOfFocusId);
        this.completedReviews[index].reviewDetails.areaOfFocus = selectedAreaFocusDetail.problemName;
      }
    });
  }

  goToCompletedGabadooReview(reviewInfo){
    this.router.navigateByUrl('/gaba-plan/' + reviewInfo.reviewDetails._id, { state: reviewInfo });
  }

}
